import { router } from '@inertiajs/react'

// Inertia の SPA ナビゲーションに対して GA4 の page_view を送信する。
// 初回ロードはレイアウトの gtag('config') が自動送信するため、
// navigate イベントの初回分はスキップして二重計上を防ぐ。
// GA が無効な環境では window.gtag が存在しないため何もしない。
// createInertiaApp より前に呼び出して初回 navigate イベントを捕捉すること。
export function initAnalytics() {
  if (typeof window.gtag !== 'function') return

  let isInitialLoad = true
  router.on('navigate', () => {
    if (isInitialLoad) {
      isInitialLoad = false
      return
    }
    window.gtag?.('event', 'page_view', {
      page_location: window.location.href,
      page_title: document.title,
    })
  })
}

// 問い合わせ送信成功時に GA4 推奨イベント generate_lead を送信する（コンバージョン計測）。
// Inertia の onSuccess（成功時のみ発火）から呼び出すこと。クリック計測だと
// バリデーションエラー / Turnstile 弾き / レート制限 / 連打 を誤計上する。
// 個人情報は送らない（イベント名のみ）。GA が無効な環境では window.gtag が存在しないため何もしない。
export function trackGenerateLead() {
  window.gtag?.('event', 'generate_lead')
}
